<template>
    <common-blade>
        <template v-slot:divider>
            <el-divider content-position="left">我的高意向客户</el-divider>
        </template>
        <template v-slot:search>

        </template>
        <template v-slot:operate>
            <type-in icon="el-icon-edit-outline">
                <template v-slot:content>
                    <base-card simple>
                        <template v-slot:content>
                            <type-in-content @loadTable="loadTable" />
                        </template>
                    </base-card>
                </template>
            </type-in>
        </template>
        <template v-slot:table>
            <el-table height="calc(100vh - 4.6rem)" v-loading="loading" :data="tableData"
                style="width: 100%;margin-top: 0.2rem" border size="mini" :header-cell-style="{
                    background: '#ecf4ff',
                    color: '#333',
                    fontWeight: '900',
                    fontSize: '0.28rem'
                }" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.4)">
                <el-table-column prop="id" label="ID" width="80" align="center">
                </el-table-column>
                <el-table-column prop="name" label="名称" width="195" show-overflow-tooltip align="center">
                </el-table-column>
                <el-table-column prop="level" label="意向等级" width="90" show-overflow-tooltip align="center">
                    <template slot-scope="scope">
                        <el-tag :type="MEANLEVEL[scope.row.level]" size="mini" effect="dark">
                            {{ scope.row.level }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="mean_cash" label="意向金额" width="150" show-overflow-tooltip align="center">
                    <template slot-scope="scope">
                        ￥{{ scope.row.mean_cash }}
                    </template>
                </el-table-column>
                <el-table-column prop="mean_from_cn" label="意向来源" width="90" show-overflow-tooltip align="center">
                    <template slot-scope="scope">
                        <el-tag :type="MEANFROM[scope.row.mean_from]" size="mini" effect="dark">
                            {{ scope.row.mean_from_cn }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="mean_type_cn" label="业务分类" width="90" show-overflow-tooltip align="center">
                    <template slot-scope="scope">
                        <el-tag :type="MEANTYPE[scope.row.mean_type]" size="mini" effect="dark">
                            {{ scope.row.mean_type_cn }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="content" label="备注" width="230" show-overflow-tooltip align="center">
                </el-table-column>
                <el-table-column prop="created_at" label="创建时间" width="150" show-overflow-tooltip align="center">
                </el-table-column>
                <!-- <el-table-column label="操作" fixed="right" width="165">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="反馈" placement="top">
                            <el-button @click="openFeed(scope.row)" type="primary" size="mini" icon="el-icon-notebook-2"
                                circle>
                            </el-button>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="客户回复短信最新消息" placement="top">
                            <el-button @click="openDrawer_smsHistory(scope.row)" type="primary" size="mini"
                                icon="el-icon-chat-line-square" circle>
                            </el-button>
                        </el-tooltip>
                        <el-dropdown style="margin-left: 0.2rem">
                            <span class="el-dropdown-link">
                                更多<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item icon="el-icon-message"
                                    @click.native="handleOpenSingleMessageDrawer(scope.row)">发送短信</el-dropdown-item>
                                <el-dropdown-item icon="el-icon-edit-outline"
                                    @click.native="openDrawer_typeInPhone(scope.row)">录入手机号</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </template>
                </el-table-column> -->
            </el-table>
            <div style="text-align: right;">
                <pagination-com :total="total" :perPage="pageSize" :npage="npage" @handleSizeChange="handleSizeChange"
                    @handleCurrentChange="handleCurrentChange" />
            </div>
        </template>
    </common-blade>
</template>

<script>
import { AutoHyperfHost } from '@/config'
export default {
    name: 'HighIntentCustomer',
    components: {
        'common-blade': () => import('@/blade/CommonBlade'),
        'pagination-com': () => import('@/commonReform/PaginationCom'),
        'type-in': () => import('@/commonReform/TypeIn'),
        'base-card': () => import('@/PureElementUi/V2.12.0/Card/BaseCard'),
        'type-in-content': () => import('@/pages/cloudClue/HighIntent/Components/TypeIn')
    },
    data() {
        return {
            loading: true,
            tableData: [],
            pageSize: 30,
            total: 0,
            npage: 1,
            MEANLEVEL: { 'A': 'danger', 'B': '', 'C': 'warning', 'D': 'info' },
            MEANFROM: { 1: 'danger', '2': 'warning' },
            MEANTYPE: { 1: 'warning', '2': 'success' }
        }
    },
    methods: {
        loadTable() {
            this.loading = true
            this.$axios.get(`${AutoHyperfHost}qyh/high_intent_customer/index?page=${this.npage}`, {
                loadingClose: true,
                params: {
                    perPage: this.pageSize,
                    // cate: this.$route.params.cate,
                    // keyword: this.$route.params.keyword,
                    // searchArr: this.searchArr,
                    // keyword: this.kw,
                    // manage: this.manageData
                },
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.loading = false
                    this.tableData = data.data.data
                    this.total = data.data.total
                }
            }).catch()
        },
        handleSizeChange(val) {
            this.npage = 1;
            this.pageSize = val;
            this.loadTable();
        },
        handleCurrentChange(val) {
            this.npage = val;
            this.loadTable();
        },
    },
    // mounted() {
    //     this.loadTable()
    // }
    created() {
        this.loadTable()
    }
}  
</script>


// WEBPACK FOOTER //
// src/pages/cloudClue/HighIntentCustomer.vue